import {useEffect} from "react";
import {type BlockerFunction, useBlocker} from "react-router-dom";

const MAIN_SCREEN_PATHS = new Set(["/app", "/guest"]);
const BOOKING_PATH = "/app/booking";

const normalizePathname = (pathname: string) => {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }

  return pathname;
};

export const BackNavigationGuard = () => {
  const blocker = useBlocker((({currentLocation, nextLocation, historyAction}) => {
    if (historyAction !== "POP") {
      return false;
    }

    const currentPathname = normalizePathname(currentLocation.pathname);
    const nextPathname = normalizePathname(nextLocation.pathname);

    return MAIN_SCREEN_PATHS.has(currentPathname) || nextPathname === BOOKING_PATH;
  }) satisfies BlockerFunction);

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
  }, [blocker]);

  return null;
};
